module.exports = __webpack_public_path__ + "413a16e0.webp";